<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('form_dashboard_search') ||
                  '订单编号/客户订单编号/识别单号/业务人员 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openChangeSales()"
            >
              {{ $l('btn_changeSales') || '业务人员变更' }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openChangeBiz()"
            >
              {{ $l('btn_changeBiz') || '跟单人员变更' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="135px"
        size="small"
        label-position="right"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderStatus') || '订单状态'"
            >
              <el-checkbox-group v-model="form.orderInfoStatusList">
                <el-checkbox label="N">{{
                  $l('INDEX.order_status_N') || '新增'
                }}</el-checkbox>
                <el-checkbox label="S">{{
                  $l('INDEX.order_status_S') || '已提交'
                }}</el-checkbox>
                <el-checkbox label="Y">{{
                  $l('INDEX.order_status_Y') || '已审核'
                }}</el-checkbox>
                <el-checkbox label="P">{{
                  $l('INDEX.order_status_P') || '进行中'
                }}</el-checkbox>
                <el-checkbox label="C">{{
                  $l('INDEX.order_status_C') || '已完成'
                }}</el-checkbox>
                <el-checkbox label="D">{{
                  $l('INDEX.order_status_D') || '已删除'
                }}</el-checkbox>
                <el-checkbox label="R">{{
                  $l('INDEX.order_status_R') || '已驳回'
                }}</el-checkbox>
                <el-checkbox label="T">{{
                  $l('INDEX.order_status_T') || '已终止'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderNo') || '订单编号'"
            >
              <el-input v-model.trim="form.orderNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_custOrderNo') || '客户订单编号'
              "
            >
              <el-input v-model.trim="form.custOrderNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_identifyNo') || '识别单号'"
            >
              <el-input v-model.trim="form.identifyNo" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_salesPersonCode') || '业务人员'
              "
            >
              <dict-select
                clearable
                v-model="form.salesPersonCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_business_person') ||
                    '请选择业务人员'
                "
                :selectedLabel.sync="form.salesPersonName"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_bizPersonCode') || '跟单人员'"
            >
              <dict-select
                clearable
                v-model="form.bizPersonCode"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('INDEX.form_label_please_select_a_business_person') ||
                    '请选择业务人员'
                "
                :selectedLabel.sync="form.bizPersonName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('INDEX.order_form_label_custCode') || '下单客户'"
            >
              <dict-select
                clearable
                v-model="form.custCode"
                filterable
                url="/master/common/dict/customerSelect"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              size="small"
              :label="$l('INDEX.order_form_label_endCustCode') || '终端客户'"
            >
              <dict-select
                clearable
                v-model="form.endCustCode"
                filterable
                url="/master/common/dict/customerSelect"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderType') || '订单类型'"
            >
              <dict-select
                size="small"
                clearable
                multiple
                filterable
                v-model.trim="form.orderTypeList"
                :body="orderTypeParams"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderSource') || '订单来源'"
            >
              <dict-select
                size="small"
                clearable
                multiple
                filterable
                v-model.trim="form.orderSourceList"
                :body="orderSourceTypeParams"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_orderExecuteType') || '执行方式'
              "
            >
              <dict-select
                size="small"
                clearable
                multiple
                filterable
                v-model.trim="form.orderExecuteTypeList"
                :body="orderExecuteTypeParams"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_scmCode') || '执行工厂'"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.scmCode"
                :body="{}"
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderScmCode') || '名义工厂'"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.orderScmCode"
                :body="{}"
                url="/master/common/dict/scmPartners"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_form_label_salesSeason') || '销售季节'"
            >
              <dict-select
                size="small"
                clearable
                multiple
                filterable
                v-model.trim="form.salesSeasonList"
                :body="salesSeasonParams"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_importanceLevel') || '重要级别'
              "
            >
              <dict-select
                size="small"
                clearable
                multiple
                filterable
                v-model.trim="form.importanceLevelList"
                :body="importanceLevelParams"
                url="/master/common/dict/biz"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="createTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="modifyTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.order_form_label_submitTime') || '提交时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.submitTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="submitTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.submitTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="submitTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.order_form_label_reviewTime') || '审核时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="reviewTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.reviewTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="reviewTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="
                  $l('INDEX.order_form_label_customerComfirmTime_view') ||
                    '客户下单日期'
                "
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.customerComfirmTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="customerComfirmTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.customerComfirmTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="customerComfirmTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.order_form_label_deliveryDay') || '交货日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDayStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="deliveryDayStartPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDayEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :picker-options="deliveryDayEndPicker"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>

    <change-form
      v-if="changeFormVisible"
      :visible.sync="changeFormVisible"
      :type="changeFormType"
      @reload="() => $emit('reload')"
      @confirmChange="confirmChange"
    />
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  orderInfoStatusList: ['N', 'S', 'Y', 'P', 'C', 'R'],
}

import changeForm from '../change-form'
export default {
  components: {changeForm},
  data() {
    return {
      orderTypeParams: {dictType: 'orderType'},
      orderSourceTypeParams: {dictType: 'orderSource'},
      orderStatusParams: {dictType: 'orderStatus'},
      orderExecuteTypeParams: {dictType: 'orderExecuteType'},
      quotedMethodParams: {dictType: 'quotedMethod'},
      technologyLevelParams: {dictType: 'technologyLevel'},
      importanceLevelParams: {dictType: 'importanceLevel'},
      urgentLevelParams: {dictType: 'urgentLevel'},
      salesSeasonParams: {dictType: 'salesSeason'},
      advqueryDialogVisible: false,
      form: {...initForm},

      changeFormVisible: false,
      changeFormType:'changeSales',

      //提交日期限制
      submitTimeStartPicker: this.submitTimeEnd(),
      submitTimeEndPicker: this.submitTimeStart(),
      //审核日期限制
      reviewTimeStartPicker: this.reviewTimeEnd(),
      reviewTimeEndPicker: this.reviewTimeStart(),
      //创建日期限制
      createTimeStartPicker: this.createTimeEnd(),
      createTimeEndPicker: this.createTimeStart(),

      //修改日期限制
      modifyTimeStartPicker: this.modifyTimeEnd(),
      modifyTimeEndPicker: this.modifyTimeStart(),

      //客户下单日期
      customerComfirmTimeStartPicker: this.customerComfirmTimeEnd(),
      customerComfirmTimeEndPicker: this.customerComfirmTimeStart(),

      //交货日期
      deliveryDayStartPicker: this.deliveryDayEnd(),
      deliveryDayEndPicker: this.deliveryDayStart(),
    }
  },

  activated() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({isReset = true} = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = {...initForm}
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    openChangeSales(){
      this.changeFormType = 'changeSales'
      this.changeFormVisible = true
    },
    openChangeBiz(){
      this.changeFormType = 'changeBiz'
      this.changeFormVisible = true
    },
    confirmChange(params){
      this.$emit('confirmChange',params)
    },

    // 修改时间限制
    modifyTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.modifyTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    modifyTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.modifyTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 提交时间限制
    submitTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.submitTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.submitTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    submitTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.submitTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.submitTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    //审核日期限制
    reviewTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.reviewTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.reviewTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    reviewTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.reviewTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.reviewTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    // 创建日期限制
    createTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.createTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    createTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.createTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.createTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    //客户下单日期限制
    customerComfirmTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.customerComfirmTimeEnd) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.customerComfirmTimeEnd).getTime() <
              time.getTime()
            )
          }
        },
      }
    },
    customerComfirmTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.customerComfirmTimeStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.customerComfirmTimeStart).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    //交货日期限制
    deliveryDayEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.deliveryDayEnd) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.deliveryDayEnd).getTime() < time.getTime()
          }
        },
      }
    },
    deliveryDayStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.deliveryDayStart) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.deliveryDayStart).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
